import { app, TAPUME_FLAG } from 'core';
import { useGetFeatureFlag } from 'ui/hooks';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export const useTapume = () => {
  const dispatch = useDispatch();

  const { value: isTapume, loading: loadingToggle } = useGetFeatureFlag(TAPUME_FLAG, false);

  useEffect(() => {
    if (loadingToggle) {
      return;
    }

    dispatch(app.actions.preflightFlow(isTapume));
  }, [loadingToggle]);
};
